import MinerName from "../MinerName/MinerName";
import Status from "../Status/Status";
import RejectedChart from "@components/global/RejectedChart";
import { IMinerProps } from "./Miner.props";
import cn from "classnames";
import styles from "./Miner.module.scss";
import { useMinerControl } from "./useMinerControl";
import TooltipText from "../TooltipText/TooltipText";
import MinerFlag from "../MinerFlag/MinerFlag";
import { getDevivedHash } from "@utils/hash.utils";

export default function Miner({
  children,
  bottomClassName,
  ...props
}: IMinerProps) {
  const {
    miner_name,
    miner_id,
    status,
    rejected,
    accepted,
    user_color,
    useFullName,
    speed,

    updateFlagRackItem,
    setOptimize,
  } = props;
  const control = useMinerControl(props);

  const hideFlag = !updateFlagRackItem;

  const showFlag =
    !!control.currentMeta?.flagText || !!control.currentMeta?.flagColor
      ? true
      : control.showFlag && !hideFlag;

  return (
    <div
      className={styles.wrapper}
      onMouseEnter={() => control.onChangeShowFlag(true)}
      onMouseLeave={() => {
        if (control.flagOpened) return;
        control.onChangeShowFlag(false);
      }}
    >
      <MinerName
        minerId={miner_id}
        useFullName={useFullName || !miner_name}
        setOptimize={setOptimize}
        copyPopoverPlacement={props.copyPopoverPlacement}
        canCopy
      >
        {miner_name || miner_id.toString()}
      </MinerName>
      <div className={cn(styles.middle)}>
        <div className={styles.data}>
          <Status
            status={status}
            className={styles.status}
            speed={speed}
            crop
          />
          {showFlag && !hideFlag && (
            <MinerFlag
              className={styles.flag}
              minerId={miner_id}
              meta={control.currentMeta}
              afterOpen={control.afterFlagOpened}
              optionalFunc={updateFlagRackItem}
            />
          )}
          <RejectedChart
            rejected={rejected}
            accepted={accepted}
            className={styles.rejected}
          />
        </div>
        {/* <Icon
          src={arrow}
          className={styles.arrow}
          onClick={control.openMinerInfo}
          disHover
        /> */}
      </div>
      <TooltipText
        placement='leftTop'
        text={control.user?.email || ""}
        afterOpenChange={control.loadUser}
        loading={!control.user}
      >
        <div
          className={cn(styles.bottom, bottomClassName)}
          style={{ backgroundColor: user_color }}
        >
          {children}
        </div>
      </TooltipText>
    </div>
  );
}
